<ng-content></ng-content>
<ng-container *ngFor="let link of menu">
    <a class="link" [routerLink]="link.link"
       *ngIf="!(link?.children?.length > 0); else section">{{ link?.title }}</a>
    <ng-template #section>
        <app-footer-menu [menu]="link.children"
                         [direction]="direction == 'column' ? 'row' : 'column'">
            <span class="title">{{ link?.title }}</span>
        </app-footer-menu>
    </ng-template>
</ng-container>
